import { routes } from '@routes';

type TLocation = {
  pathname: string;
  search: string;
  hash: string;
};

export const getSigninRedirectPath = ({ pathname, search, hash }: TLocation): string => {
  if (pathname === '/') {
    return routes.signin.make();
  }

  const searchParams = new URLSearchParams({ goto: `${pathname}${search}${hash}` });

  return `${routes.signin.make()}?${searchParams.toString()}`;
};
